import { createContext, Dispatch, SetStateAction, useContext } from "react";

import { MENTION_TYPE, Sentiment } from "@/constants";
import { TimeCluster } from "@/containers/Episode/utils/clusterTimes";
import { Episode } from "@/types/Episode";
import { AudioMention, Mention } from "@/types/Mention";

export type EpisodeContextType = {
  hideActions?: boolean;
  hideSimilar?: boolean;
  hideMetadata?: boolean;
  hideReach?: boolean;
  hideSentiment?: boolean;
  hidePrValue?: boolean;
  hideTags?: boolean;
  searchIsProcessing?: boolean;
  clusters: TimeCluster[];
  is_paywalled?: boolean;
  is_report?: boolean;
  visibleMentions?: number;
  show?: string;
  removeAll: () => void;
  removeSource: () => void;
  removeIndividual: (id: string) => void;
  removedMentionIds: string[];
  removedSource: boolean;
  undoRemoveMention: (id: string[], unhide_source?: boolean) => void;

  sentimentActive: boolean;
  setSentimentActive: Dispatch<SetStateAction<boolean>>;

  // split of the mentions
  audioMentions: AudioMention[];
  textMentions: Mention<typeof MENTION_TYPE.TEXT_POST>[];
  episodeNameMentions: Mention<typeof MENTION_TYPE.EPISODE_NAME>[];
  updateMentionSentiment: (public_id: Mention, sentiment: Sentiment) => void;
  updateAggregatedSentiment: (sentiment: Sentiment) => void;
  episodeDescriptionMentions: Mention<
    typeof MENTION_TYPE.EPISODE_DESCRIPTION
  >[];
  channelTitleMentions: Mention<typeof MENTION_TYPE.CHANNEL_TITLE>[];
  mediaModalOpen: boolean;
  setMediaModalOpen: Dispatch<SetStateAction<boolean>>;
  readerModalOpen: boolean;
  setReaderModalOpen: Dispatch<SetStateAction<boolean>>;
  // Translation methods
  translateMention: <T = Mention>(
    mention: T,
    fromKey?: keyof T,
    toKey?: keyof T
  ) => void;
  unTranslateMention: <T = Mention>(mention: T, toKey?: keyof T) => void;
} & Episode &
  Pick<Episode, "post_data">;

const EpisodeContext = createContext<EpisodeContextType>(
  {} as EpisodeContextType
);

export const useEpisode = () => useContext(EpisodeContext);

export default EpisodeContext;
